import React from "react";
import ManageTreatmentPackages from "../organisms/packages-and-treatments/manage-treatment-packages";
import PackagesAndTreatmentsPopupsAndDrawers from "../organisms/packages-and-treatments/packages-and-treatments-popups-and-drawers";
import { track } from "../utils/tracking";

const ManageTreatmentPackagesScreen = () => {
  React.useEffect(() => {
    track("manage_treatment_packages_screen");
  }, []);

  return (
    <>
      <ManageTreatmentPackages />
      <PackagesAndTreatmentsPopupsAndDrawers />
    </>
  );
};

export default ManageTreatmentPackagesScreen;
